import { apiClient } from './client';
import { downloadPdfBlob } from '../utils/downloadPdf';
import {
  InternalDraft,
  InternalDraftAttachment,
  InternalDraftPayload,
} from '../types/internalDraft';

export async function fetchInternalDrafts(
  keyword?: string,
  contractId?: number | null
): Promise<InternalDraft[]> {
  const params: Record<string, string | number> = {};
  if (keyword?.trim()) params.q = keyword.trim();
  if (contractId != null) params.contractId = contractId;
  const { data } = await apiClient.get<InternalDraft[]>('/internal-drafts', {
    params: Object.keys(params).length ? params : undefined,
  });
  return data;
}

export async function fetchInternalDraft(internalDraftId: number): Promise<InternalDraft> {
  const { data } = await apiClient.get<InternalDraft>(`/internal-drafts/${internalDraftId}`);
  return data;
}

export async function createInternalDraft(payload: InternalDraftPayload): Promise<InternalDraft> {
  const { data } = await apiClient.post<InternalDraft>('/internal-drafts', payload);
  return data;
}

export async function updateInternalDraft(
  internalDraftId: number,
  payload: InternalDraftPayload
): Promise<InternalDraft> {
  const { data } = await apiClient.patch<InternalDraft>(
    `/internal-drafts/${internalDraftId}`,
    payload
  );
  return data;
}

export async function deleteInternalDraft(internalDraftId: number): Promise<void> {
  await apiClient.delete(`/internal-drafts/${internalDraftId}`);
}

export async function approveInternalDraft(internalDraftId: number): Promise<InternalDraft> {
  const { data } = await apiClient.post<InternalDraft>(`/internal-drafts/${internalDraftId}/approve`);
  return data;
}

export async function revokeInternalDraft(internalDraftId: number): Promise<InternalDraft> {
  const { data } = await apiClient.post<InternalDraft>(`/internal-drafts/${internalDraftId}/revoke`);
  return data;
}

export async function uploadInternalDraftAttachments(
  internalDraftId: number,
  files: File[]
): Promise<InternalDraftAttachment[]> {
  const form = new FormData();
  files.forEach((file) => form.append('files', file));
  const { data } = await apiClient.post<InternalDraftAttachment[]>(
    `/internal-drafts/${internalDraftId}/attachments`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}

export async function deleteInternalDraftAttachment(
  internalDraftId: number,
  attachmentId: number
): Promise<void> {
  await apiClient.delete(`/internal-drafts/${internalDraftId}/attachments/${attachmentId}`);
}

export async function downloadInternalDraftAttachment(
  internalDraftId: number,
  attachmentId: number,
  fileName: string
): Promise<void> {
  const { data } = await apiClient.get<Blob>(
    `/internal-drafts/${internalDraftId}/attachments/${attachmentId}/download`,
    { responseType: 'blob' }
  );
  const url = window.URL.createObjectURL(data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  window.URL.revokeObjectURL(url);
}


export async function downloadInternalDraftPdf(
  internalDraftId: number,
  fileName?: string
): Promise<void> {
  await downloadPdfBlob(
    `/internal-drafts/${internalDraftId}/pdf`,
    fileName || `내부기안서_${internalDraftId}.pdf`
  );
}
